import type { ScheduleSolversDisplayConfigType } from '../../types';

export const noRepeat = ({
  userDate,
  startDate,
  endDate
}: ScheduleSolversDisplayConfigType) => {
  return (
    userDate.getTime() <= endDate.getTime() &&
    userDate.getTime() >= startDate.getTime()
  );
};
